var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullscreenFrontageDialog',{ref:"frontageDialog",scopedSlots:_vm._u([{key:"default",fn:function(dialogProps){return [_c('CopyLink',{attrs:{"uid":dialogProps.uid,"title":dialogProps.title,"link":dialogProps.link,"source":dialogProps.source},on:{"close":_vm.handleClose}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }